/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

import videos from '../../../../videos/index';
import { useThemeClassName } from '../../../contexts/ThemeContext';

import styles from '../../../../styles/displays/slides/video.module.scss';

const propTypes = {
    title: PropTypes.string,
    videoName: PropTypes.string,
};

const defaultProps = {
    title: null,
    videoName: null,
};

function VideoSlide({ title, videoName }) {
    const themeClassName = useThemeClassName(styles);
    // const video = videoName !== null ? videos[videoName] || null : videoName;
    const onVideoEnded = useCallback(() => {
        // console.log('video endedeee');
    }, []);

    const video = videos.find(({ id: videoId }) => videoId === videoName) || null;

    return (
        <div className={classNames([styles.container, themeClassName])}>
            {video !== null ? (
                <video
                    className={styles.video}
                    alt={title}
                    preload="auto"
                    muted
                    playsInline
                    autoPlay
                    onEnded={onVideoEnded}
                >
                    <source src={`${video.mp4}#t=0.1`} type="video/mp4" />
                    <source src={`${video.webm}#t=0.1`} type="video/webm" />
                </video>
            ) : null}
        </div>
    );
}

VideoSlide.propTypes = propTypes;
VideoSlide.defaultProps = defaultProps;

export default VideoSlide;
